import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CompanySetupService } from '../../modules/company-setup/services/company-setup.service';

/** Guard for blocking application usage until company completes their location and bill */
export const companySetupGuard: CanActivateFn = () => {
  const router = inject(Router);
  const companySetup = inject(CompanySetupService);
  if (!companySetup.isCompanySetupComplete()) {
    router.navigate(['setup']);
    return false;
  } else {
    return true;
  }
};

/** Guard for blocking setup route after company completes their location and bill */
export const companySetupComletedGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const companySetup = inject(CompanySetupService);
  if (companySetup.isCompanySetupComplete()) {
    router.navigate(['']);
    return false;
  } else {
    return true;
  }
};
